import {
  AbcIcon,
  AprovaLiveIcon,
  BeakerIcon,
  bioquimicaIcon,
  CalculatorIcon,
  ComplementaryIcon,
  ContractIcon,
  CornerstoneIcon,
  DnaIcon,
  DumbbellIcon,
  embriologiaIcon,
  EnemIcon,
  EnglishIcon,
  farmacologiaIcon,
  fisiologiaIcon,
  geneticaIcon,
  GlobeIcon,
  histologiaIcon,
  imunologiaIcon,
  IntersectionIcon,
  microbiologiaIcon,
  MoleculeIcon,
  MonitoryIcon,
  OwlIcon,
  parasitologiaIcon,
  patologiaIcon,
  PencilIcon,
  RegionsIcon,
  SpanishIcon,
  SquadIcon,
  TempleIcon,
} from 'morpheus-ui';
import { anatomiaIcon } from '../../../../components/atoms/AnatomiaIcon';
import { Permissions } from '../../../../accessControl/permissions';
import { IMenuItem } from '../menuBar/menuItems';

export const menuItems: IMenuItem[] = [
  {
    id: 'minha-area',
    label: 'Minha Área',
    icon: 'home',
    iconType: 'material',
    items: [],
    old: false,
    href: '/minha-area',
    clickable: true,
    permission: Permissions.MINHA_AREA,
  },
  {
    id: 'cursos',
    label: 'Trilhas',
    icon: 'ads_click',
    iconType: 'material',
    old: false,
    clickable: false,
    href: '/cursos',
    items: [
      {
        id: 'cronograma',
        label: 'Cronograma Personalizado',
        icon: 'view_kanban',
        iconType: 'material',
        old: false,
        link: '/plano-adaptativo',
        permission: Permissions.TRILHAS_DE_ENSINO_CRONOGRAMA_PERSONALIZADO,
      },
      {
        id: 'cursos-regulares',
        label: 'Cursos Regulares',
        icon: 'extension',
        iconType: 'material',
        old: false,
        link: '/cursos/regulares',
        permission: Permissions.TRILHAS_DE_ENSINO_CURSOS_REGULARES,
      },
      {
        label: 'Cursos Complementares',
        icon: ComplementaryIcon,
        iconType: 'svg',
        old: false,
        link: '/cursos/complementares',
        permission: Permissions.TRILHAS_DE_ENSINO_CURSOS_COMPLEMENTARES,
      },
      {
        id: 'treino-de-elite',
        label: 'Estudo por Questões',
        icon: DumbbellIcon,
        iconType: 'svg',
        old: false,
        link: '/cursos/minicurso-treino-de-elite/detalhes',
        permission: Permissions.TRILHAS_DE_ENSINO_TREINO_DE_ELITE,
      },
      {
        id: 'esquadrao',
        label: 'Esquadrão',
        icon: SquadIcon,
        iconType: 'svg',
        old: false,
        link: '/cursos/esquadrao-elite/detalhes',
        permission: Permissions.TRILHAS_DE_ENSINO_ESQUADRAO,
      },
      {
        id: 'regionais',
        label: 'Regionais',
        icon: RegionsIcon,
        iconType: 'svg',
        link: '/regionais',
        old: false,
        permission: Permissions.TRILHAS_DE_ENSINO_REGIONAIS,
      },
    ],
  },
  {
    id: 'disciplinas',
    label: 'Disciplinas',
    icon: 'neurology',
    iconType: 'material',
    old: false,
    clickable: false,
    href: '/disciplinas',
    items: [
      {
        label: 'Interdisciplinar',
        icon: IntersectionIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/interdisciplinar',
        permission: Permissions.DISCIPLINAS_INTERDISCIPLINAR,
      },
      {
        label: 'Biologia',
        icon: DnaIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/biologia',
        permission: Permissions.DISCIPLINAS_BIOLOGIA,
      },
      {
        label: 'Química',
        icon: BeakerIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/quimica',
        permission: Permissions.DISCIPLINAS_QUIMICA,
      },
      {
        label: 'Física',
        icon: MoleculeIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/fisica',
        permission: Permissions.DISCIPLINAS_FISICA,
      },
      {
        label: 'História',
        icon: CornerstoneIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/historia',
        permission: Permissions.DISCIPLINAS_HISTORIA,
      },
      {
        label: 'Geografia',
        icon: GlobeIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/geografia',
        permission: Permissions.DISCIPLINAS_GEOGRAFIA,
      },
      {
        label: 'Atualidades',
        icon: ContractIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/atualidades',
        permission: Permissions.DISCIPLINAS_ATUALIDADES,
      },
      {
        label: 'Matemática',
        icon: CalculatorIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/matematica',
        permission: Permissions.DISCIPLINAS_MATEMATICA,
      },
      {
        label: 'Sociologia',
        icon: TempleIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/sociologia',
        permission: Permissions.DISCIPLINAS_SOCIOLOGIA,
      },
      {
        label: 'Filosofia',
        icon: OwlIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/filosofia',
        permission: Permissions.DISCIPLINAS_FILOSOFIA,
      },
      {
        label: 'Português',
        icon: PencilIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/portugues',
        permission: Permissions.DISCIPLINAS_PORTUGUES,
      },
      {
        label: 'Literatura',
        icon: AbcIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/literatura',
        permission: Permissions.DISCIPLINAS_LITERATURA,
      },
      {
        label: 'Redação',
        icon: AbcIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/redacao',
        permission: Permissions.DISCIPLINAS_REDACAO,
      },
      {
        label: 'Inglês',
        icon: EnglishIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/ingles',
        permission: Permissions.DISCIPLINAS_INGLES,
      },
      {
        label: 'Espanhol',
        icon: SpanishIcon,
        iconSize: 'large',
        iconType: 'svg',
        old: false,
        link: '/disciplinas/espanhol',
        permission: Permissions.DISCIPLINAS_ESPANHOL,
      },
    ],
  },
  {
    id: 'universitario',
    label: 'Universitário',
    icon: 'school',
    iconType: 'material',
    old: false,
    clickable: false,
    href: '/disciplinas',
    items: [
      {
        id: '6744f33373342c8bdf624e8e',
        link: '/disciplinas/bioquimica-superior',
        label: 'Bioquímica',
        icon: bioquimicaIcon,
        permission: Permissions.DISCIPLINAS_BIOQUIMICA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '6744f2ce73342c8bdf624b31',
        link: '/disciplinas/anatomia-superior',
        label: 'Anatomia Humana',
        icon: anatomiaIcon,
        permission: Permissions.DISCIPLINAS_ANATOMIA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '6744f3a173342c8bdf62523c',
        link: '/disciplinas/histologia-humana-superior',
        label: 'Histologia Humana',
        icon: histologiaIcon,
        permission: Permissions.DISCIPLINAS_HISTOLOGIA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '67a649de53385405e8347d57',
        link: '/disciplinas/fisiologia-superior',
        label: 'Fisiologia Humana',
        icon: fisiologiaIcon,
        permission: Permissions.DISCIPLINAS_FISIOLOGIA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '67a649e94a2955b1abd77d7a',
        link: '/disciplinas/genetica-superior',
        label: 'Genética',
        icon: geneticaIcon,
        permission: Permissions.DISCIPLINAS_GENETICA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '67a649c2b5df925acf3d5ae2',
        link: '/disciplinas/embriologia-superior',
        label: 'Embriologia',
        icon: embriologiaIcon,
        permission: Permissions.DISCIPLINAS_EMBRIOLOGIA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '6744f40a73342c8bdf6255c0',
        link: '/disciplinas/imunologia-superior',
        label: 'Imunologia',
        icon: imunologiaIcon,
        permission: Permissions.DISCIPLINAS_IMUNOLOGIA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '6744f47773342c8bdf625936',
        link: '/disciplinas/microbiologia-superior',
        label: 'Microbiologia',
        icon: microbiologiaIcon,
        permission: Permissions.DISCIPLINAS_MICROBIOLOGIA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '6744f51e73342c8bdf625ed2',
        link: '/disciplinas/parasitologia-superior',
        label: 'Parasitologia',
        icon: parasitologiaIcon,
        permission: Permissions.DISCIPLINAS_PARASITOLOGIA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '6744f4c973342c8bdf625bfc',
        link: '/disciplinas/patologia-superior',
        label: 'Patologia',
        icon: patologiaIcon,
        permission: Permissions.DISCIPLINAS_PATOLOGIA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
      {
        id: '67a649d154e8a222fe439241',
        link: '/disciplinas/farmacologia-superior',
        label: 'Farmacologia',
        icon: farmacologiaIcon,
        permission: Permissions.DISCIPLINAS_FARMACOLOGIA,
        iconType: 'svg',
        iconSize: 'large',
        old: false,
        isNew: false,
      },
    ],
  },
  {
    id: 'redacao',
    label: 'Redação',
    icon: 'edit',
    iconType: 'material',
    old: true,
    clickable: false,
    href: '/redacoes',
    items: [
      {
        label: 'Minhas Redações',
        icon: 'stylus',
        iconType: 'material',
        link: '/redacoes/minhas_redacoes',
        old: false,
        permission: Permissions.REDACAO_MINHAS_REDACOES,
      },
      {
        label: 'Temas de Redação',
        icon: 'list',
        iconType: 'material',
        link: '/redacoes/temas',
        old: false,
        permission: Permissions.REDACAO_TEMAS,
      },
    ],
  },
  {
    id: 'mais',
    label: 'Mais',
    icon: 'menu',
    iconType: 'material',
    old: false,
    clickable: false,
    href: '/mais',
    items: [
      {
        label: 'Sair',
        icon: 'logout',
        iconType: 'material',
        link: '/logout',
        old: false,
        permission: Permissions.ALL,
      },
      {
        label: 'Perfil',
        icon: 'person',
        iconType: 'material',
        link: '/perfil',
        old: false,
        permission: Permissions.ALL,
      },
      {
        label: 'Fale conosco',
        icon: 'contact_support',
        iconType: 'material',
        link: 'https://ajuda.aprovatotal.com.br/hc/aprova-total/pt_BR',
        externalLink: true,
        old: false,
        permission: Permissions.ALUNO_APROVA_TOTAL,
      },
      {
        label: 'Comunidade',
        icon: 'supervisor_account',
        iconType: 'material',
        link: '/comunidade',
        old: false,
        permission: Permissions.ALL,
      },
      {
        label: 'Favoritos',
        icon: 'star',
        iconType: 'material',
        link: '/favoritos',
        old: false,
        permission: Permissions.FAVORITOS,
      },
      {
        label: 'Conexões com Jubilut',
        icon: 'diversity_3',
        iconType: 'material',
        link: '/conexoes-jubilut',
        old: false,
        permission: Permissions.CONEXOES_JUBILUT,
      },
      {
        label: 'Monitorias',
        icon: MonitoryIcon,
        iconSize: 'regular',
        iconType: 'svg',
        link: '/ao-vivo/monitorias',
        old: false,
        permission: Permissions.AO_VIVO_MONITORIAS,
      },
      {
        label: 'Lives',
        icon: 'live_tv',
        iconType: 'material',
        link: '/ao-vivo/lives',
        old: false,
        permission: Permissions.AO_VIVO_LIVES,
      },
      {
        label: 'AprovaLive',
        icon: AprovaLiveIcon,
        iconSize: 'regular',
        iconType: 'svg',
        link: '/ao-vivo/aprova-live',
        old: false,
        permission: Permissions.AO_VIVO_APROVA_LIVE,
      },
      // {
      //   permission: Permissions.AO_VIVO_CHALLENGE_60_DIAS,
      //   label: 'Desafio 60 dias',
      //   icon: AprovaLiveIcon,
      //   iconSize: 'regular',
      //   iconType: 'svg',
      //   link: '/ao-vivo/desafio-60-dias',
      //   old: false,
      //   isNew: false,
      // },
      {
        label: 'Indicação',
        icon: 'group_add',
        iconType: 'material',
        link: '/referidos',
        old: false,
        permission: Permissions.ALL,
      },
      {
        label: 'Banco de Questões',
        icon: 'quiz',
        iconType: 'material',
        link: '/banco-questoes',
        old: false,
        permission: Permissions.SIMULADOS_SIMULADOR,
      },
      {
        label: 'Simulador',
        icon: 'timer',
        iconType: 'material',
        link: '/simulados/provas',
        old: false,
        permission: Permissions.SIMULADOS_SIMULADOR,
      },
      {
        label: 'Flashcards',
        icon: 'timelapse',
        iconType: 'material',
        permission: Permissions.MEMORY,
        old: false,
        link: '/memory',
      },
      {
        label: 'Simulados Enem',
        icon: EnemIcon,
        iconSize: 'regular',
        iconType: 'svg',
        link: '/simulados/enem',
        old: false,
        permission: Permissions.SIMULADOS_SIMULADOS_ENEM,
      },
      {
        label: 'Provas ENEM',
        icon: 'history_edu',
        iconType: 'material',
        link: '/area-enem',
        old: false,
        permission: Permissions.SIMULADOS_SIMULADOS_ENEM,
      },
    ],
  },
];

export const planoAdaptativoMenuItems: IMenuItem[] = [
  {
    label: 'Minha Área',
    icon: 'home',
    href: '/',
    iconType: 'material',
    old: false,
    clickable: true,
    permission: Permissions.ALL,
    items: [],
  },
  {
    label: 'Painel',
    icon: 'dashboard',
    href: 'hub',
    iconType: 'material',
    old: false,
    clickable: true,
    permission: Permissions.ALL,
    items: [],
  },
  {
    label: 'Conteúdo das Disciplinas',
    icon: 'description',
    href: 'disciplinas',
    iconType: 'material',
    old: false,
    clickable: true,
    permission: Permissions.ALL,
    items: [],
  },
  {
    label: 'Cronograma Completo',
    icon: 'view_compact',
    href: 'completo',
    iconType: 'material',
    old: false,
    clickable: true,
    permission: Permissions.ALL,
    items: [],
  },
  {
    label: 'Progresso das Disciplinas',
    icon: 'dashboard',
    href: 'resumo',
    iconType: 'material',
    old: false,
    clickable: true,
    permission: Permissions.ALL,
    items: [],
  },
];
